<template>
  <ModalBase :show="show" @close="close()">
    <h3 class="modal-heading">Skickat!</h3>
    <span class="alert alert-success">
      <i class="fas fa-check"></i>Vi har tagit emot ditt meddelande!
    </span>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/ModalBase.vue'

export default {
  name: 'SuccessSiteContact',
  props: ['show'],
  components: {
    ModalBase
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
